import { render, staticRenderFns } from "./AppointmentDetailsParticipantsListItem.vue?vue&type=template&id=c84e190c&scoped=true&"
import script from "./AppointmentDetailsParticipantsListItem.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDetailsParticipantsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84e190c",
  null
  
)

export default component.exports